export default {
  env: 'production',
  apiUrl: 'https://api.referoo.co',
  sentryEnv: 'production', // /jv/ can't use above 'env' because it looks like its used as part of build process however I could not find how or where it is used.
};
